import { api, authApi } from "./api";


export const getSchoolRecordIsShowApi = (userId) => authApi.get(`/school-record/is-show/${userId}`)

/* School Record - new (ver1-1) */
// // GET: 생활기록부 리스트 조회
// export const getSchoolRecordListApi = (userId, searchTerm) => authApi.get(`/school-record/list/${userId}?searchTerm=${searchTerm}`)
// // GET: 생활기록부 내용 조회
// export const getSchoolRecordInfoApi = (schoolRecordId) => authApi.get(`/school-record/${schoolRecordId}`)


/* School Record ver2 */
// GET: 생활기록부 리스트 조회
export const getSchoolRecordListApi = (userId, searchTerm) => authApi.get(`/school-record/ver2/list/${userId}?searchTerm=${searchTerm}`)

// GET: 생활기록부 조회
export const getSchoolRecordInfoApi = (schoolRecordId) => authApi.get(`/school-record/ver2/${schoolRecordId}`)